<template src="./template.html"></template>

<script>
  import { mapActions } from 'vuex'

  export default {
    props: { item: Object },
    methods: {
      ...mapActions('summary', ['removeItem']),
      remove(e, item) {
        e.preventDefault()
        this.removeItem(item.id).then(() => {
          /* eslint-disable no-undef */
          if (typeof $.updateBonusSldrInCheckout === 'function') {
            $.updateBonusSldrInCheckout()
          }
          /* eslint-enable no-undef */
        })
      },
    },
  }
</script>
